import api from './api';

export async function fetchChatContacts() {
  // Backend mounts this under /api; include prefix to avoid 404s
  const res = await api.get('/api/second-hand-offers/chat-contacts');
  return res.data.data || [];
}
